import React from "react";

const T = "#0D9488", B = "#006090", N = "#013A5A", G = "#C9A227";

const Team = () => (
  <svg viewBox="0 0 120 80" className="w-full h-20" aria-hidden><circle cx="60" cy="26" r="11" fill={B} /><rect x="45" y="40" width="30" height="26" rx="12" fill={B} />
    <circle cx="30" cy="34" r="8" fill={T} /><rect x="19" y="45" width="22" height="20" rx="9" fill={T} /><circle cx="90" cy="34" r="8" fill={T} /><rect x="79" y="45" width="22" height="20" rx="9" fill={T} />
    <circle cx="104" cy="16" r="7" fill="none" stroke={G} strokeWidth="2" strokeDasharray="3 2" /><path d="M104 12v8M100 16h8" stroke={G} strokeWidth="2" /></svg>);
const Flow = () => (
  <svg viewBox="0 0 120 80" className="w-full h-20" aria-hidden><rect x="6" y="28" width="28" height="24" rx="6" fill={B} /><rect x="46" y="28" width="28" height="24" rx="6" fill={T} /><rect x="86" y="28" width="28" height="24" rx="6" fill={N} />
    <path d="M34 40h12M74 40h12" stroke={G} strokeWidth="3" markerEnd="url(#a)" /><defs><marker id="a" viewBox="0 0 6 6" refX="3" refY="3" markerWidth="4" markerHeight="4" orient="auto"><path d="M0 0L6 3L0 6z" fill={G} /></marker></defs></svg>);
const Chart = () => (
  <svg viewBox="0 0 120 80" className="w-full h-20" aria-hidden><rect x="14" y="44" width="14" height="26" rx="3" fill={T} /><rect x="36" y="34" width="14" height="36" rx="3" fill={B} />
    <rect x="58" y="38" width="14" height="32" rx="3" fill={T} /><rect x="80" y="26" width="14" height="44" rx="3" fill={B} /><path d="M12 40L42 28L64 32L100 14" fill="none" stroke={G} strokeWidth="3" strokeLinecap="round" /></svg>);
const Cycle = () => (
  <svg viewBox="0 0 120 80" className="w-full h-20" aria-hidden><circle cx="60" cy="40" r="26" fill="none" stroke={B} strokeWidth="6" strokeDasharray="120 44" /><circle cx="60" cy="40" r="26" fill="none" stroke={T} strokeWidth="6" strokeDasharray="40 124" strokeDashoffset="-124" />
    <text x="60" y="46" textAnchor="middle" fontSize="18" fontWeight="700" fill={G}>$</text></svg>);

export const THEMES = [
  { key: "team", title: "Build Your Team", Art: Team, anchor: "section-team" },
  { key: "systems", title: "Put Your Systems to Work", Art: Flow, anchor: "section-systems" },
  { key: "retain", title: "Grow and Retain Your Business", Art: Chart, anchor: "section-metrics" },
  { key: "reinvest", title: "Reinvest and Improve", Art: Cycle, anchor: "section-reinvest" },
];

export function GrowthPath({ content }) {
  return (
    <section aria-labelledby="growth-path-h" data-testid="growth-path">
      <h2 id="growth-path-h" className="font-display text-base md:text-lg font-bold text-slate-900">Four growth themes</h2>
      <p className="text-xs text-slate-500 mb-3">District coaching themes. They aren't official Farmers achievement levels or required program phases.</p>
      <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 relative">
        {THEMES.map(({ key, title, Art, anchor }, i) => (
          <li key={key} className="relative">
            <a href={`#${anchor}`} className="block h-full rounded-2xl border border-slate-200 bg-white p-4 hover:border-[#006090] hover:shadow-md transition-[box-shadow,border-color] group" data-testid={`growth-theme-${key}`}>
              <span className="text-[11px] font-bold text-[#006090]">THEME {i + 1}</span>
              <Art />
              <p className="font-semibold text-slate-900 group-hover:text-[#006090]">{title}</p>
              <p className="text-sm text-slate-600 mt-1">{content[`theme_${key}`]}</p>
            </a>
            {i < 3 && <span aria-hidden className="hidden lg:block absolute top-1/2 -right-2.5 w-3 h-0.5 bg-[#C9A227] z-10" />}
          </li>))}
      </ol>
    </section>
  );
}
